<template>
  <!-- 首页-banner轮播 -->
  <div class="index-banner">
    <div class="banner-top">
      <div class="banner-topimg">
        <el-image style="width: 100%; height: 333px" :src="require('@/assets/images/baotou_ban1.png')"></el-image>
      </div>
      <div class="banner-titlebox">
        <span class="banner1-title">包头市知识产权智慧监管公共服务平台</span>
      </div>
    </div>
    <router-link to="/patent/search" class="banner-routerlink">
      <div class="banner-bannerbox">
        <div class="bannerimgbox">
          <el-image style="width: 100%; height: 76px" :src="require('@/assets/images/Picture1.png')"></el-image>
        </div>
        <div class="banner-titlebox">
          <div class="banner2-title">
            <span>知识产权数据服务</span>
            <i class="banner2-rightimg"></i>
          </div>
        </div>
      </div>
    </router-link>
    <router-link to="/requirement/index">
      <div class="banner-bannerbox">
        <div class="bannerimgbox">
          <el-image style="width: 100%; height: 76px" :src="require('@/assets/images/Picture2.png')"></el-image>
        </div>
        <div class="banner-titlebox">
          <div class="banner3-title">
            <span>知识产权运营服务</span>
            <i class="banner2-rightimg"></i>
          </div>
        </div>
      </div>
    </router-link>
    <router-link to="/demand/index">
      <div class="banner-bannerbox">
        <div class="bannerimgbox">
          <el-image style="width: 100%; height: 76px" :src="require('@/assets/images/Picture3.png')"></el-image>
        </div>
        <div class="banner-titlebox">
          <div class="banner4-title">
            <span>知识产权质押融资服务</span>
            <i class="banner2-rightimg"></i>
          </div>
        </div>
      </div>
    </router-link>
    <router-link to="/network/index">
      <div class="banner-bannerbox">
        <div class="bannerimgbox">
          <el-image style="width: 100%; height: 76px" :src="require('@/assets/images/Picture4.png')"></el-image>
        </div>
        <div class="banner-titlebox">
          <div class="banner5-title">
            <span>知识产权智慧监管服务</span>
            <i class="banner2-rightimg"></i>
          </div>
        </div>
      </div>
    </router-link>
  </div>

  <!-- <el-carousel :interval="5000" arrow="always">
      <el-carousel-item v-for="item in 4" :key="item">
        <h3>{{ item }}</h3>
      </el-carousel-item>
    </el-carousel> -->
  <!-- <el-carousel height="333px" :interval="5000">
      <el-carousel-item class="scroll-banner">
        <div class="banner-box">
          <img
            class="banner-img banner-img1"
            src="@/assets/images/baotou_ban1.png"
          />
          <div class="banner1-titlebox">
            <span class="banner1-title"
              >包头市知识产权智慧监管公共服务平台</span
            >
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item class="scroll-banner">
        <div class="banner-box">
          <img
            class="banner-img banner-img2"
            src="@/assets/images/baotou_ban2.png"
          />
          <div class="banner2-ban2con">
            <div>
              <span class="banner2-title">知识产权数据服务</span>
              <ul class="banner2-ban2list">
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>专利数据库
                </li>
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>商标数据库
                </li>
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>知识产权榜单
                </li>
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>知识产权动态追踪
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item class="scroll-banner">
        <div class="banner-box">
          <a href="https://screen.wanxiangyun.net/" target="_blank">
          <img class="banner-img" src="@/assets/images/baotou_banner3.png" />
          <div class="banner2-ban2con banner3-ban3con">
            <div>
              <span class="banner3-title">知识产权运营服务</span>
              <ul class="banner2-ban2list banner3-ban3list">
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>发布交易需求
                </li>
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>查询可运营专利
                </li>
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>在线智能匹配
                </li>
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>对接运营服务机构
                </li>
              </ul>
            </div>
          </div>
          </a>
        </div>
      </el-carousel-item>
      <el-carousel-item class="scroll-banner">
        <div class="banner-box">
          <img class="banner-img" src="@/assets/images/baotou_banner4.png" />
          <div class="banner2-ban2con">
            <div>
              <span class="banner2-title">知识产权质押融资服务</span>
              <ul class="banner2-ban2list">
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>浏览服务机构
                </li>
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>智能匹配融资产品
                </li>
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>在线申请和提交
                </li>
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>服务进度追踪
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item class="scroll-banner">
        <div class="banner-box">
          <img class="banner-img" src="@/assets/images/baotou_banner5.png" />
          <div class="banner2-ban2con banner5-ban5con">
            <div>
              <span class="banner2-title">知识产权智慧监管服务</span>
              <ul class="banner2-ban2list banner5-ban5list">
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>知识产权网络监管
                </li>
                <li class="ban2list-ban2li">
                  <i class="ban2li-ban2point"></i>知识产权侵权假冒检测
                </li>
              </ul>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel> -->
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style>
.index-banner {
  width: 100%;
}
.banner-top {
  position: relative;
  height: 330px;
  width: 100%;
}
.banner-topimg {
  position: absolute;
  width: 100%;
  height: 333px;
  top: 0;
  left: 0;
}

.banner-titlebox {
  position: relative;
  width: 1440px;
  height: 330px;
  margin: 0 auto;
}
.banner1-title {
  position: absolute;
  top: 80px;
  left: 60px;
  font-weight: 700;
  font-size: 28px;
  z-index: 10;
  color: #d42a2a;
}

.banner-bannerbox {
  position: relative;
  width: 100%;
  height: 76px;
}
.bannerimgbox {
  position: absolute;
  height: 76px;
  width: 100%;
  left: 0;
  height: 0;
}
.banner-titlebox {
  position: relative;
  width: 1440px;
  height: 76px;
  margin: 0 auto;
}
.banner2-title {
  position: absolute;
  top: 0;
  left: 80px;
  color: #ffffff;
  font-weight: 700;
  font-size: 24px;
  line-height: 76px;
  letter-spacing: 8px;
}
.banner3-title {
  position: absolute;
  top: 0px;
  left: 390px;
  color: #ffffff;
  font-weight: 700;
  font-size: 24px;
  line-height: 76px;
  letter-spacing: 8px;
}
.banner4-title {
  position: absolute;
  top: 0px;
  left: 705px;
  color: #ffffff;
  font-weight: 700;
  font-size: 24px;
  line-height: 76px;
  letter-spacing: 8px;
}
.banner5-title {
  position: absolute;
  top: 0px;
  left: 1080px;
  color: #ffffff;
  font-weight: 700;
  font-size: 24px;
  line-height: 76px;
  letter-spacing: 8px;
}
.banner2-rightimg {
  display: block;
  width: 30px;
  margin-left: 10px;
  margin-top: 24px;
  height: 30px;
  float: right;
  background-image: url(@/assets/images/righ-banner.png);
  clear: both;
}
/* .scroll-banner {
  height: 333px;
  overflow: hidden;
}
.banner-box {
  position: relative;
  height: 333px;
  overflow: hidden;
}
.banner-img {
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -300px;
  min-height: 333px;
  max-height: 600px;
  width: 100%;
  height: auto;
}
.banner-img1,
.banner-img2 {
  top: 0;
  margin-top: 0;
  height: 333px;
}
.banner1-titlebox {
  position: relative;
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
  text-align: left;
} */

/* .banner2-ban2con {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
}
.banner2-ban2con div {
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.banner2-ban2con::after {
  display: block;
  content: "";
  float: left;
}

.banner2-ban2list {
  position: absolute;
  top: 80px;
  right: 80px;
  width: 210px;
  height: 150px;
  line-height: 22px;
  box-sizing: border-box;
  text-align: left;
  color: #ffffff;
  font-size: 22px;
}
.ban2list-ban2li {
  position: relative;
  margin-bottom: 15px;
  padding-left: 30px;
} */
/* .ban2li-ban2point {
  position: absolute;
  top: 7px;
  left: 0;
  display: block;
  width: 7px;
  height: 7px;
  background: #ffffff;
  border-radius: 50%;
}
.el-carousel__button {
  display: block;
  opacity: 0.78;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #fff;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
}
.is-active .el-carousel__button {
  background: #de3a3a;
}
.banner3-ban3con {
} */
/* .banner3-title {
  position: absolute;
  bottom: 80px;
  left: 80px;
  color: #ffffff;
  font-weight: 700;
  font-size: 28px;
  letter-spacing: 10px;
}
.banner3-ban3list {
  position: absolute;
  top: 110px;
  right: 80px;
  width: 210px;
  line-height: 22px;
  text-align: left;
  color: #ffffff;
  font-size: 22px;
}
.banner5-ban5con {
}
.banner5-ban5list {
  position: absolute;
  top: 180px;
  left: 80px;
  width: 300px;
  height: 150px;
  line-height: 22px;
  box-sizing: border-box;
  text-align: left;
  color: #ffffff;
  font-size: 22px;
} */
</style>
